import Cropper from "react-easy-crop";

class CFPSCropper extends Cropper {
  componentDidUpdate(prevProps) {
    if (
      prevProps.aspect !== this.props.aspect ||
      prevProps.panelWidth !== this.props.panelWidth ||
      prevProps.panelPosition !== this.props.panelPosition
    ) {
      this.computeSizes();
    } else if (prevProps.zoom !== this.props.zoom) {
      this.recomputeCropPosition();
    }
  }
}

export default CFPSCropper;
